import "./languageLocation.css";

const LanguageLocation = () => {
  return (
    <div className="left-side-laguage-location">
      <h4>Location Language</h4>{" "}
    </div>
  );
};

export default LanguageLocation;
